import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { SheetMappingRequest, SheetMappingMutationResponse } from '../types/import-configuration-types';

/**
 * Use case for creating or updating a sheet mapping
 */
export class SaveSheetMappingUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(request: SheetMappingRequest): Promise<SheetMappingMutationResponse> {
    return this.repository.saveSheetMapping(request);
  }
}
